<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @taskSubmit="taskSubmitFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.type"
              placeholder="请选择需求类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.executeMethod"
              placeholder="请选择需求执行方式"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in executeMethodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择申请状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.materialsStatus"
              placeholder="请选择物料状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in materialsStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @submit="submitFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 修改 方案物料需求 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditFromSchemeVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 新增 方案外物料需求 -->
    <add-custom-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 修改 方案外物料需求 -->
    <edit-custom-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />

    <task-submit-dialog
      :dialog-visible.sync="dialogTaskSubmitVisible"
      :dialog-title="dialogTaskTitle"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 修改 方案物料需求
import addEditDialog from './components/addEditDialog'
// 新增 方案外物料需求
import addCustomDialog from './components/addCustomDialog'
// 修改 方案外物料需求
import editCustomDialog from './components/editCustomDialog'
// 查看
import viewDialog from './components/viewDialog'
// 待办列表
import taskSubmitDialog from './components/taskSubmitDialog'
// 数据请求
import { loadMaterialsDemandListDataApi, loadMaterialsDemandExportDataApi, countTodoMaterialsDemandApi, removeMaterialsDemandApi, submitMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsDemand',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    addCustomDialog,
    editCustomDialog,
    viewDialog,
    taskSubmitDialog,
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_demand_detail', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['demand_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['demand_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['demand_submit'],
            prop: 'submit',
            label: '提交',
            method: 'submit'
          },
          {
            permissionSigns: ['demand_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['demand_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['demand_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            materialsName: '',
            type: '',
            executeMethod: '',
            materialsStatus: '',
            status: ''
          }
        },
        notPaging: true
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['demand_submit'],
          label: '待提交物料需求申请',
          method: 'taskSubmit',
          count: 0
        }
      ],
      typeOptions: [{ value: 1, label: '方案内需求' }, { value: 2, label: '方案外需求' }],
      executeMethodOptions: [{ value: 1, label: '申请制作/购买' }, { value: 2, label: '现有库存满足' }, { value: 3, label: '外部租赁' }, { value: 4, label: '自有物资满足' }],
      statusOptions: [{ value: 1, label: '制单' }, { value: 3, label: '提交' }, { value: 4, label: '审核' }],
      materialsStatusOptions: [{ value: 0, label: '-' }, { value: 11, label: '未制作' }, { value: 12, label: '制作中' }, { value: 13, label: '已发货' }, { value: 21, label: '未调出' }, { value: 22, label: '已调出' }, { value: 31, label: '未租赁' }, { value: 32, label: '已租赁' }, { value: 41, label: '已满足' }, { value: 51, label: '已收货' }],
      yesOrNoOptions: [{ value: 1, label: '是' }, { value: 0, label: '否' }],
      auditResultOptions: [{ value: 1, label: '新制作/购买' }, { value: 2, label: '调拨' }, { value: 3, label: '外部租赁' }, { value: 4, label: '不执行(不结算)' }, { value: 5, label: '退回' }],
      id: null, // 选中的单据ID
      eventType: '',
      // 弹框组件标题名称
      dialogTitle: '',
      // 方案外需求新增弹框组件
      dialogAddVisible: false,
      // 方案外需求修改弹框组件
      dialogEditVisible: false,
      // 方案需求修改弹框组件
      dialogAddEditFromSchemeVisible: false,
      // 查看弹框组件
      dialogViewVisible: false,
      // 需求申請提交待辦彈框組件
      dialogTaskSubmitVisible: false,
      dialogTaskTitle: ''
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      // { prop: 'typeValue', label: '需求类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 105 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
      { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 90 },
      { prop: 'demandSide', label: '需求方', filterColumn: 'demand_side', width: 120 },
      { prop: 'schemeContent', label: '需求来源', filterColumn: 'scheme_content', width: 200 },
      { prop: 'materialsName', label: '制作物料名称', filterColumn: 'materials_name', width: 150 },
      { prop: 'applyMakeNumber', label: '制作物料数量', filterColumn: 'apply_make_number', width: 125, isBetween: true },
      { prop: 'isExecuteValue', label: '是否执行需求', filterColumn: 'is_execute', filterValue: 'isExecute', filterArray: [{ label: '执行', value: 1 }, { label: '不执行(不结算)', value: 2 }], width: 125 },
      { prop: 'executeMethodValue', label: '需求执行方式', filterColumn: 'execute_method', filterValue: 'executeMethod', filterArray: this.executeMethodOptions, width: 130 },
      { prop: 'auditResultValue', label: '审核意见', filterColumn: 'audit_result', filterValue: 'auditResult', filterArray: this.auditResultOptions, width: 110 },
      { prop: 'confirmSupplierValue', label: '供应方', filterColumn: 'confirm_supplier', filterValue: 'confirmSupplier', filterArray: [{ label: '未确认', value: 0 }, { label: '总部制作', value: 1 }, { label: '当地制作', value: 2 }], width: 100 },
      { prop: 'remark', label: '备注', width: 150 },
      { prop: 'materialsStatusValue', label: '需求满足进度', filterColumn: 'materials_status', filterValue: 'materialsStatus', filterArray: this.materialsStatusOptions, width: 125 },
      { prop: 'supplierName', label: '供应商名称', filterColumn: 'supplier_name', width: 150 },
      { prop: 'estimatedCompleteDateValue', label: '预计制作完成时间', filterColumn: 'estimated_complete_date', width: 150 },
      { prop: 'shipmentDateValue', label: '发货时间', filterColumn: 'shipment_date', width: 120 },
      { prop: 'transferMethodValue', label: '运输方式', filterColumn: 'transfer_method', filterValue: 'transferMethod', filterArray: [{ label: '自提', value: 1 }, { label: '快递', value: 2 }, { label: '物流', value: 3 }, { label: '其他', value: 4 }], width: 120 },
      { prop: 'arrivalDateValue', label: '实际到货时间', filterColumn: 'arrival_date', width: 130 },
      { prop: 'statusValue', label: '申请状态', filterColumn: 'status', filterValue: 'status', filterArray: this.statusOptions, width: 110 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme_no', width: 200 },
      { prop: 'demandMaterialsName', label: '需求物料名称', filterColumn: 'demand_materials_name', width: 150 },
      { prop: 'demandMaterialsNumber', label: '需求物料数量', filterColumn: 'demand_materials_number', width: 125, isBetween: true },
      { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 100 },
      { prop: 'createTimeValue', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'submitterName', filterColumn: 'submitter_name', label: '提交人', width: 100 },
      { prop: 'submitTimeValue', filterColumn: 'submit_time', label: '提交时间', width: 150, isBetween: true },
      { prop: 'auditorName', filterColumn: 'auditor_name', label: '审核人', width: 100 },
      { prop: 'auditTimeValue', filterColumn: 'audit_time', label: '审核时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = false
      loadMaterialsDemandListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待提交物料需求申请数量
      countTodoMaterialsDemandApi({ status: '1' }).then(res => {
        this.todoList[0].count = res.data || 0
      })
    },
    // 提交待办
    taskSubmitFun () {
      this.dialogTaskTitle = '物料需求申请待提交清单'
      this.dialogTaskSubmitVisible = !this.dialogTaskSubmitVisible
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddVisible = !this.dialogAddVisible
      this.dialogTitle = '新增物料需求申请'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的物料需求申请', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '物料需求申请不是制单状态，不能修改', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogTitle = '修改物料需求申请'
      if (args[0].type === 1) {
        this.dialogAddEditFromSchemeVisible = !this.dialogAddEditFromSchemeVisible
      } else {
        this.dialogEditVisible = !this.dialogEditVisible
      }
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的物料需求申请', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的物料需求申请', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '物料需求申请不是制单状态，不能作废', type: 'warning' })
        return
      }
      this.$confirm('是否确定作废该物料需求申请？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        removeMaterialsDemandApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 提交
    submitFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要提交的物料需求申请', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '物料需求申请不是制单状态，不能提交', type: 'warning' })
        return
      }
      this.$confirm('是否确定提交该物料需求申请？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        submitMaterialsDemandApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadMaterialsDemandExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
